// Portal externo TierraScore: se sirve en la raíz de los HOSTS DEL PORTAL o, mientras tanto, bajo /portal en el dominio de Tecnomyl.
// Único lugar para ampliar dominios del portal (el backend tiene la misma lista en backend/portal.py → DOMINIOS_PORTAL).
export const DOMINIOS_PORTAL = ["agroinmueblespy.com", "tierrascore.com"];
const hostEnDominio = (host, d) => host === d || host.endsWith("." + d);
// Deploy dedicado a TierraScore: el sistema interno de Tecnomyl no se sirve en ninguna dirección (poner en false para reactivarlo).
export const SOLO_PORTAL = true;
export const esHostPortal = () => {
  if (typeof window === "undefined") return false;
  if (SOLO_PORTAL) return true;
  const h = window.location.hostname.toLowerCase();
  return /^inmuebles\./.test(h) || h.includes("agroinmuebles") || DOMINIOS_PORTAL.some((d) => hostEnDominio(h, d));
};
export const esPortal = () => esHostPortal() || (typeof window !== "undefined" && window.location.pathname.startsWith("/portal"));
export const portalBase = () => (esHostPortal() ? "" : "/portal");
export const MARCA = { nombre: "TierraScore", lema: "Inmuebles, catastro y satélite para el análisis de crédito agro" };
